export const CErrorOnboardingContext = {
    ONBOARDING_WELCOME_PAGE: 'ONBOARDING_WELCOME_PAGE',
    ONBOARDING_KYC_STARTED:'ONBOARDING_KYC_STARTED',
    ONBOARDING_APPROVED_FLOW:'ONBOARDING_APPROVED_FLOW',
    ONBOARDING_ADD_TEEN_START: 'ONBOARDING_ADD_TEEN_START',
    ONBOARDING_ADD_TEEN_COMPLETED: 'ONBOARDING_ADD_TEEN_COMPLETED',
    ONBOARDING_GET_CARD_THEME: 'ONBOARDING_GET_CARD_THEME'
} as const;